import Image from 'next/image';

import { LandingPageProps } from '..';

import promise1Image from './images/promise/1.png';
import promise2Image from './images/promise/2.png';
import promise3Image from './images/promise/3.png';
import promise4Image from './images/promise/4.png';

type PromiseItem = {
  title: string;
  image: StaticImageData;
  description: JSX.Element;
};

type PromiseDescriptionProps = {
  promiseItem: PromiseItem;
};

const PromiseDescription: React.FC<PromiseDescriptionProps> = ({
  promiseItem,
}) => {
  return (
    <div className="flex basis-1/4 flex-col items-center justify-center">
      <div className="relative mb-5 flex w-full md:mb-2">
        <Image alt="" src={promiseItem.image} className="block w-full" />
        <div className="absolute bottom-0 bg-white p-1 font-bold drop-shadow md:bottom-3">
          {promiseItem.title}
        </div>
      </div>
      <div className="w-full px-1 text-[13px]">{promiseItem.description}</div>
    </div>
  );
};

type Props = {
  lpProps: LandingPageProps;
};

const Component: React.FC<Props> = ({ lpProps }) => {
  const promiseItems: PromiseItem[] = [
    {
      title: '独自の最新指導法',
      image: promise1Image,
      description: (
        <>
          指導実績豊富なコーチや、主要大会で結果を残す選手が多く出演！
          <br />
          現代卓球の技術を、革新的な指導法を用いて、あなたを導いていきます。
        </>
      ),
    },
    {
      title: '動画でわかりやすく',
      image: promise2Image,
      description: (
        <>
          写真やテキストでは分かりづらいフォームやテクニックも、高画質な動画で簡単チェック！
          <br />
          スロー映像も交え、より理解できる！
        </>
      ),
    },
    {
      title: 'いつ、どこからでも',
      image: promise3Image,
      description: (
        <>
          スマホやタブレット、PCで隙間時間ですぐ練習を！
          <br />
          あなたの練習場は卓球台の前だけではありません。
        </>
      ),
    },
    {
      title: 'リーズナブルな料金',
      image: promise4Image,
      description: (
        <>
          Shakehandsだけのオリジナルコンテンツを月額¥{lpProps.price}（税込¥
          {lpProps.priceWithTax}）
          で使い放題！お財布にやさしい料金で、無理なく長く続けていただきます。
        </>
      ),
    },
  ];
  return (
    <div className="mt-4 grid w-full grid-cols-2 grid-rows-2 items-start gap-4 md:grid-cols-4 md:grid-rows-1 md:gap-x-5">
      {promiseItems.map(promiseItem => (
        <PromiseDescription key={promiseItem.title} promiseItem={promiseItem} />
      ))}
    </div>
  );
};

export default Component;
